import { appeler } from './callable';

/**
 * Le tableau de bord, demande au serveur.
 *
 * Rien n'est calcule ici : ce qu'il montre demande de lire la fiche de
 * tout le monde, et aucun telephone n'a ce droit. La fonction
 * `tableauDeBord` fait le compte et ne renvoie qu'un resume, a qui porte
 * le role `admin`.
 */

export interface LigneDeMembre {
  pseudo: string;
  /** Millisecondes ; zero pour un compte jamais revenu. */
  vuA: number;
  coquille: number | null;
  spot: string | null;
}

export interface SortieDuTableau {
  titre: string;
  spot: string;
  date: string;
  heure: string;
  spontane: boolean;
  inscrits: number;
  places: number;
}

export interface TableauDeBord {
  membres: {
    total: number;
    actifs24h: number;
    actifs7j: number;
    nouveaux7j: number;
    derniers: LigneDeMembre[];
  };
  versions: { nom: string; combien: number }[];
  sorties: { aVenir: number; prochaines: SortieDuTableau[] };
  signalements: { ouverts: number };
  /** Ce qui dit qu'un serveur vit, du plus actif au moins actif. */
  parServeur: ServeurDuTableau[];
  /** `n` comptes sur `sur` : revenus apres leur premiere semaine, encore la apres un mois. */
  retention: { revenus: Part; encoreActifs: Part };
  /** Les inscriptions des huit dernieres semaines, la plus ancienne d'abord. */
  inscriptions: number[];
  /** Les trente derniers jours, tous serveurs confondus. */
  mois: { posts: number; tenues: number; presences: number };
}

export interface Part {
  n: number;
  sur: number;
}

export interface ServeurDuTableau {
  nom: string;
  membres: number;
  actifs7j: number;
  posts7j: number;
  tenues30j: number;
  aVenir: number;
  presences30j: number;
}

export function lireLeTableau(): Promise<TableauDeBord> {
  return appeler<Record<string, never>, TableauDeBord>('tableauDeBord', {});
}
